import { render, staticRenderFns } from "./DaftarAktivaTetap.vue?vue&type=template&id=50813ef6&scoped=true"
import script from "./DaftarAktivaTetap.vue?vue&type=script&lang=js"
export * from "./DaftarAktivaTetap.vue?vue&type=script&lang=js"
import style0 from "./DaftarAktivaTetap.vue?vue&type=style&index=0&id=50813ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50813ef6",
  null
  
)

export default component.exports